import AppDataService from "./AppDataService";

const COMMON_BASE = 'Notices'

export default class NoticesDataService {
    static async getList(data){
        return await AppDataService.post(`${COMMON_BASE}/GetList`, data , {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }

    static async removeNotice(noticeid){
        return await AppDataService.delete(`${COMMON_BASE}/DeleteNotice?noticeid=${noticeid}`);
    }

    static async removeNoticeTask(noticeTasksID){
        return await AppDataService.delete(`${COMMON_BASE}/RemoveTask?NoticeTasksID=${noticeTasksID}`);
    }

    static async toggleArchiveNotice(noticeid){
        return await AppDataService.put(`${COMMON_BASE}/ToggleArchiveNotice?noticeid=${noticeid}`);
    }

    static async getNotice(params){
        return await AppDataService.get(`${COMMON_BASE}/GetNoticeRecordById`, {params});
    }

    static async getTaskList(params){
        return await AppDataService.get(`${COMMON_BASE}/GetTaskList`, {params});
    }

    static async removeNoticeNote(NoticeNoteID){
        return await AppDataService.delete(`${COMMON_BASE}/RemoveNoticeNote?NoticeNoteID=${NoticeNoteID}`);
    }

    static async addNoticeGetAssigneeByPayerId(params){
        return await AppDataService.get(`${COMMON_BASE}/AddNoticeGetAssigneeByPayerId`, {params});
    }

    static async getStatusList(){
        return await AppDataService.get(`${COMMON_BASE}/GetStatusList`);
    }

    static async inviteClient(data){
        return await AppDataService.post(`${COMMON_BASE}/InviteClient`, data);
    }

    static async saveNoticeNote(data){
        return await AppDataService.post(`${COMMON_BASE}/SaveNoticeNote`, data);
    }

    static async saveTaskNote(data){
        return await AppDataService.post(`${COMMON_BASE}/SaveNoticeTaskNote`, data);
    }

    static async removeNoticeFile(NoticeDocumentID){
        return await AppDataService.delete(`${COMMON_BASE}/RemoveFile?NoticeDocumentID=${NoticeDocumentID}`);
    }

    static async removeTaskNote(NoticeTaskNoteID){
        return await AppDataService.delete(`${COMMON_BASE}/RemoveNoticeTaskNote?NoticeTaskNoteID=${NoticeTaskNoteID}`);
    }

    static async removeTaskDocument(NoticeTaskDocumentID){
        return await AppDataService.delete(`${COMMON_BASE}/RemoveTaskFile?NoticeTaskDocumentID=${NoticeTaskDocumentID}`);
    }

    static async uploadNoticeFile(NoticeID, formData){
        return await AppDataService.post(`${COMMON_BASE}/NoticeFileUpload?NoticeID=${NoticeID}`, formData);
    }

    static async uploadTaskFile(NoticeTaskID, formData){
        return await AppDataService.post(`${COMMON_BASE}/NoticeTaskFileUpload?NoticeTaskID=${NoticeTaskID}`, formData);
    }

    static async saveNoticeTaskNote(data){
        return await AppDataService.post(`${COMMON_BASE}/SaveNoticeTaskNote`, data);
    }

    static async saveNotice(data){
        return await AppDataService.post(`${COMMON_BASE}/SaveNotice`, data);
    }

    static async saveNoticeTask(data){
        return await AppDataService.post(`${COMMON_BASE}/SaveNoticeTask`, data);
    }

    static async addNoticeDropDownData(){
        return await AppDataService.get(`${COMMON_BASE}/AddNoticeDropDownData`);
    }

    static async downloadTaskDocument(params){
        return await AppDataService.get(`${COMMON_BASE}/GetTaskfile`, {params});
    }

    static async downloadNoticeDocument(params){
        return await AppDataService.get(`${COMMON_BASE}/GetNoticefile`, {params});
    }
}